import theme from '../../themes/index.en';

const { palette, shape } = theme;
export const SignInFormStyles = {
  container: {
    display: 'flex',
    flexDirection: 'column' as 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    padding: '1rem',
    zIndex: 1000,
  },
  box: {
    maxWidth: '400px',
    display: 'flex',
    flexDirection: 'column' as 'column',
    alignItems: 'center',
    padding: '20px',
    border: `2px solid ${palette.background.default}`,
    borderRadius: shape.borderRadius,
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    background: palette.background.default,
    color: palette.primary.main,
  },
  logo: {
    marginBottom: '20px',
  },
  form: {
    width: '100%',
  },
  button: {
    marginTop: '24px',
    marginBottom: '16px',
    backgroundColor: palette.primary.main,
    color: palette.text.secondary,
    '&:hover': {
      backgroundColor: `${palette.primary.main}`
    },
  },
  disableButton: {
    marginTop: '24px',
    marginBottom: '16px',
    backgroundColor: palette.action.disabled,
    color: palette.text.secondary,
    cursor: 'not-allowed',
  },
  '@media screen and (max-width: 600px)': {
    box: {
      width: '90%',
    },
  },
  '@media screen and (min-width: 601px) and (max-width: 1024px)': {
    box: {
      width: '95%',
    },
  },
  '@media screen and (min-width: 1025px) and (max-width: 1440px)': {
    box: {
      width: '100%',
    },
  },
  '@media screen and (min-width: 1441px)': {
    box: {
      width: '100%',
    },
  },
};
